import { ThemeEvents } from '@theme/events';

class CartFreeShippingProgress extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate.bind(this), {
      signal: /** @type {AbortController} */ (this.#controller).signal,
    });
  }

  disconnectedCallback() {
    if (this.#controller) {
      this.#controller.abort();
      this.#controller = null;
    }
  }

  #onCartUpdate(event) {
    const totalPrice = event?.detail?.resource?.total_price;
    if (typeof totalPrice !== 'number') return;
    this.dataset.cartTotalCents = String(totalPrice);
    this.#syncBar();
  }

  #syncBar() {
    const threshold = parseInt(this.dataset.thresholdCents || '0', 10);
    const total = parseInt(this.dataset.cartTotalCents || '0', 10);
    if (threshold <= 0) return;

    const fill = this.querySelector('.cart-free-shipping__fill');
    const track = this.querySelector('.cart-free-shipping__track');
    if (!fill || !track) return;

    const pct = Math.min(100, Math.round((total / threshold) * 100));
    fill.style.width = `${pct}%`;
    track.setAttribute('aria-valuenow', String(pct));
  }
}

if (!customElements.get('cart-free-shipping-progress')) {
  customElements.define('cart-free-shipping-progress', CartFreeShippingProgress);
}
